/**
 * @return {{feature: string}}
 */
export const incitationProfile = (data) => ({
  feature: 'avantage_profil',
  cause: data.tab,
});
